import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconReport.module.css';

const IconReport = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      id="Layer_1"
      width="800"
      height="800"
      fill="#000"
      version="1.1"
      viewBox="0 0 512 512"
    >
      <path d="M399.929 357.333c-42.35 0-76.8 34.45-76.8 76.8s34.45 76.8 76.8 76.8 76.8-34.45 76.8-76.8-34.45-76.8-76.8-76.8m0 136.534c-32.933 0-59.733-26.8-59.733-59.733s26.8-59.733 59.733-59.733 59.733 26.8 59.733 59.733-26.8 59.733-59.733 59.733"></path>
      <path d="M399.929 382.933c-18.825 0-34.133 15.308-34.133 34.133 0 4.717 3.817 8.533 8.533 8.533s8.533-3.817 8.533-8.533c0-9.408 7.658-17.067 17.067-17.067s17.067 7.658 17.067 17.067-6.521 17.067-15.929 17.067c-4.717 0-7.396 3.817-7.396 8.533v8.533c0 4.717 3.817 8.533 8.533 8.533s8.533-3.817 8.533-8.533v-1.083c8.533-3.792 24.463-17.175 24.463-33.05 0-18.824-16.446-34.133-35.271-34.133"></path>
      <path d="M403.229 0H61.979C47.837 0 35.271 10.4 35.271 24.5v460.867c0 14.1 12.542 26.633 26.65 26.633h257.158c4.717 0 8.533-3.817 8.533-8.533s-3.817-8.533-8.533-8.533H61.921c-4.7 0-9.583-4.883-9.583-9.567V24.5c0-4.683 4.917-7.433 9.642-7.433h341.25c4.65 0 7.508 2.808 7.508 7.4V323.2a8.53 8.53 0 0 0 8.533 8.533 8.53 8.53 0 0 0 8.533-8.533V24.467C427.804 10.392 417.371 0 403.229 0"></path>
      <path d="M275.271 59.733h-85.333a8.53 8.53 0 0 0-8.533 8.533 8.53 8.53 0 0 0 8.533 8.533h85.333a8.53 8.53 0 0 0 8.533-8.533 8.53 8.53 0 0 0-8.533-8.533M352.071 119.467H113.138a8.53 8.53 0 0 0-8.533 8.533 8.53 8.53 0 0 0 8.533 8.533h238.933a8.53 8.53 0 0 0 8.533-8.533 8.53 8.53 0 0 0-8.533-8.533M352.071 179.2H113.138a8.53 8.53 0 0 0-8.533 8.533 8.53 8.53 0 0 0 8.533 8.533h238.933a8.53 8.53 0 0 0 8.533-8.533 8.53 8.53 0 0 0-8.533-8.533M352.071 238.933H113.138a8.53 8.53 0 0 0-8.533 8.533 8.53 8.53 0 0 0 8.533 8.533h238.933a8.53 8.53 0 0 0 8.533-8.533 8.53 8.53 0 0 0-8.533-8.533M352.071 298.667H113.138c-4.717 0-9.6 2.75-9.6 7.467v128c0 4.717 4.883 9.6 9.6 9.6h187.733c4.717 0 8.533-3.817 8.533-8.533s-3.817-8.533-8.533-8.533H120.604V315.733h221.867v24.533a8.53 8.53 0 0 0 8.533 8.533 8.53 8.53 0 0 0 8.533-8.533v-34.133c.001-4.716-2.75-7.466-7.466-7.466"></path>
    </svg>
  );
};

const { string } = PropTypes;

IconReport.defaultProps = {
  className: null,
  rootClassName: null,
};

IconReport.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconReport;
